import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import Layout from "../components/Layout"
import Seo from "../components/layout/Seo"
import { IconArrowRight, IconMail2, IconPhone, IconPlace } from "../components/icons/Icons"
import Map from "../components/common/Map"
import ThankYouHeroBG from "../components/ThankYouHeroBG"
import AdditionalForms from "../components/common/AdditionalForms"
import HaveQuestions from "../components/common/HaveQuestions"

const WhatAreYouLookingToSell = () => {
  return (
    <Layout className={"mx-auto"} breadcrumbs={false}>
      <Seo
        title="What Are You Looking to Sell? | #1 Buyer in the US"
        description="What are you looking to sell? Sell your watches and jewelry for the most money. Fast, safe, and secure. The best online luxury goods buyer located in ..."
        canonical={"/what-are-you-looking-to-sell/"}
      />

      <AdditionalForms />
      <hr className="w-10/12 mx-auto py-10" />
      <h2 className={" text-center text-4xl uppercase"}>How it works</h2>
      <section className={"w-10/12 mx-auto max-w-[1366px] py-10"}>
        <div className={"how-it-works flex flex-wrap items-center justify-center gap-4 px-4"}>
          <Link
            to="/what-are-you-looking-to-sell-2/"
            className={"hoverScale flex-grow-0 text-center md:w-2/5 lg:w-auto lg:flex-1"}
          >
            <StaticImage src={"../images/homepage/value.png"} alt={"Valuation"} />
            <h3>Request a Quote</h3>
            <p>
              Find out how much is your watch or jewelry worth? The more information & photos you
              share with us the more accurate the market valuation will be.
            </p>
          </Link>
          <div className={"hidden flex-shrink self-center md:block"}>
            <IconArrowRight className={"text-accent"} />
          </div>
          <Link
            to="/easy-ship-box/"
            className={"hoverScale flex-grow-0 text-center md:w-2/5 lg:w-auto lg:flex-1"}
          >
            <StaticImage src={"../images/homepage/shipping.png"} alt={"Shipping"} />
            <h3>Send Us Your Jewelry</h3>
            <p>
              If you like the quote you’ll receive a pre-paid shipping label including insurance.
              Face-to-face collection can also be arranged.
            </p>
          </Link>
          <div className={"hidden flex-shrink self-center lg:block"}>
            <IconArrowRight className={"text-accent"} />
          </div>
          <div className={"flex-grow-0 text-center text-link md:w-2/5 lg:w-auto lg:flex-1"}>
            <StaticImage src={"../images/homepage/inspection.png"} alt={"Inspection"} />
            <h3>Full Jewelry Inspection</h3>
            <p>
              Once we receive your jewelry our qualified experts will inspect its condition and
              authenticity.
            </p>
          </div>
          <div className={"hidden flex-shrink self-center md:block"}>
            <IconArrowRight className={"text-accent"} />
          </div>
          <div className={"flex-grow-0 text-center text-link md:w-2/5 lg:w-auto lg:flex-1"}>
            <StaticImage src={"../images/homepage/payment.png"} alt={"Payment"} />
            <h3>Receive Payment</h3>
            <p>Once finalized you will quickly receive payment via check or wire payment.</p>
          </div>
        </div>
      </section>
      <hr className="w-10/12 mx-auto" />
      <HaveQuestions />

      <section className={"mt-16"}>
        <Map />
      </section>
    </Layout>
  )
}

export default WhatAreYouLookingToSell
